
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class KnowledgeCheckFeedback extends Vue {
  @Prop() isCorrect!: boolean;
  @Prop() correctTitle!: string;
  @Prop() correctFeedback!: string;
  @Prop() correctFeedbackImage!: string;
  @Prop() incorrectTitle!: string;
  @Prop() incorrectFeedback!: string;
  @Prop() incorrectFeedbackImage!: string;
  @Prop({default:false}) noFeedback !: boolean;

  get haveSlotedFeedback (){
    return ((!!this.$slots['feedback-correct-message'] && this.isCorrect) || (!!this.$slots['feedback-incorrect-message'] && !this.isCorrect));
  }
}
